import { default as axios, AxiosResponse } from 'axios';
import Vue from 'vue';
import Vuex, { ActionTree, MutationTree, StoreOptions } from 'vuex';
import { IRootHypermediaRepresentation } from '../shared/contracts/RootContract';
import { aggregate } from './aggregateStore';
import { barometer } from './barometerStore';
import { IAggregateState, IBarometerState, IGroupDetailsState, IRootState, IUserState } from './contract';
import { details } from './groupDetailsStore';
import { user } from './userStore';

Vue.use(Vuex);

const rootState: IRootState = {
    root: undefined,
    appLoaded: false
};

const mutations: MutationTree<IRootState> = {
    rootLoaded(state, payload: IRootHypermediaRepresentation) {
        state.root = payload;
    }
};

const actions: ActionTree<IRootState, IRootState> = {
    async fetchRoot({ commit, state }): Promise<void> {
        if (!state.root) {
            const response: AxiosResponse<IRootHypermediaRepresentation> = await axios.get('/api');
            await commit('rootLoaded', response && response.data);
        }
    }
};

const storeOptions: StoreOptions<IRootState> = {
    state: rootState,
    mutations,
    actions,
    modules: {
        aggregate,
        barometer,
        user,
        details
    }
};

// Class + interface to make typescript happy when writing something like store.state.barometer...
class JoeyStore extends Vuex.Store<IRootState> {
    state: IJoeyState;

    constructor(store: StoreOptions<IRootState>) {
        super(store);
    }
}

interface IJoeyState extends IRootState {
    aggregate: IAggregateState;
    barometer: IBarometerState;
    user: IUserState;
    details: IGroupDetailsState;
}

export default new JoeyStore(storeOptions);
